export interface ListItem {
  itemid: number;
  name: string;
  rating: number;
  notes?: string;
  tags?: string;
  pictures?: string;
  location?: string;
  datevisited: string;
  categoryid: number;
}

export async function fetchItem(id: number): Promise<ListItem> {
  try {
    const response = await fetch(`/api/item/${id}`);
    if (!response.ok) {
      throw new Error("Failed to fetch category items");
    }
    const data = await response.json();
    if (data === null) {
      throw new Error("Expected list item");
    }
    return data;
  } catch (error) {
    console.error("Error fetching category items:", error);
    return {
      itemid: 0,
      name: "",
      rating: 0,
    } as ListItem;
  }
}
export async function newItem(catid: number): Promise<number> {
  let item = {
    itemid: 0,
    name: "",
    rating: 0,
    notes: "",
    tags: "",
    pictures: "",
    location: "",
    datevisited: new Date().toISOString().split("T")[0],
    categoryid: catid,
  } as ListItem;
  let id = await saveItem(item);
  return id;
}

export async function saveItem(item: ListItem): Promise<number> {
  try {
    const response = await fetch(`/api/item`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });
    if (!response.ok) {
      throw new Error("Failed to save item");
    }
    const data = await response.json();
    if (data === null || typeof data.id !== "number") {
      throw new Error("Expected item with Id");
    }
    return data.id;
  } catch (error) {
    console.error("Error saving item:", error);
  }
  return 0;
}

export async function deleteItem(id: number): Promise<void> {
  try {
    const response = await fetch(`/api/item/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      throw new Error("Failed to delete item");
    }
  } catch (error) {
    console.error("Error deleting item:", error);
  }
}
